<div>
  <strong>{{ label | translate }}</strong>
</div>
<div>
  <ng-content></ng-content>
</div>
